import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import {
  FDStack,
} from '@facet-wealth/design';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import useMobileLayout from 'Hooks/useMobileLayout';

const PaymentDetailsSubtotalListMeta = ({
  collection,
}) => {
  const resources = collection?.resources()?.list();
  const isMobile = useMobileLayout();

  return (
    <FDStack direction={'column'} spacing={1} alignItems={isMobile ? 'flex-end' : 'flex-start'} justifyContent="flex-start">
      {resources.map((resource) => {
        const subTotal = resource.attr('subTotal');
        return (
          <Typography
            variant={'h6'}
            weight={isMobile ? 'extraBold' : 'bold'}
            color={'darkGray'}
          >
            {subTotal}
          </Typography>
        );
      })}
    </FDStack>
  );
};

PaymentDetailsSubtotalListMeta.defaultProps = {
};

PaymentDetailsSubtotalListMeta.propTypes = {
  collection: PropTypes.instanceOf(fr.Collection).isRequired,
};

export default PaymentDetailsSubtotalListMeta;
